
/** 静态变量 **/
export const PUBLIC_PATH = "//" + window.location.hostname; //本项目域名
export const OLD_USER_CENTER_URL ='//vip.qianlima.com'; //会员中心
export const CUSTOM_USER_CENTER_URL = "https://www.qianlima.com/enterprise_account/index.html"; // 定制版会员中心
export const OLD_HOME = "//www.qianlima.com"; //旧版首页;
export const OLD_HOME_ZHAOBIAO = "//zhaobiao.qianlima.com";
export const NET_WORK_PRIVACY_POLICY = `https://www.qianlima.com/QianlimaTenderingNetworkPrivacyPolicy.html`; //隐私政策;

//企业套餐
export const ENTERPRISE_PACKAGE = window.location.origin + "/enterprise-package";
//产品服务
export const PRODUCTS_SERVICES = window.location.origin + "/product-services";
export const ABOUT_US = "http://qianlima.group/"; //关于千里马

//账号信息
export const ACCOUNT_INFORMATION = OLD_USER_CENTER_URL + "/account-manage/account-info";

export const LOGIN_URL = OLD_USER_CENTER_URL + "/login"; //登录页
export const REGISTER_URL = OLD_USER_CENTER_URL + "/register.html?referUrl=" + window.location; //注册页
export const OLD_ONE_CENTER_URL = "//center.qianlima.com"; //
export const BIDDINGLIST_MORE = OLD_USER_CENTER_URL + "/business-opportunity/bidding-info"; //实时标讯-查看更多

export const DATA_MALL_URL = "http://data.qianlima.com/#/"; // 数据商城
export const USER_APPLICATION_MONITOR_URL = "//file-smallv.qianlima.com/0qlm/web_qlmFindDealer/index.html?type=1"; // 企业信息库2.0 不支持gw-static
export const DATA_CUSTOMIZATION_SERVICE_URL = OLD_HOME + "/qlmzhaotoubiao/qlm.html"; // 数据定制服务
export const BIDDING_QUERY_URL = OLD_HOME + "/zbgg"; // 招标查询
export const PROJECT_QUERY_URL = OLD_HOME + "/jxxm/"; // 项目查询
export const INSTITUTIONAL_INQUIRY_URL = OLD_HOME + "/common/agents/"; // 机构查询
export const ENGINEERING_ITEM_URL = OLD_USER_CENTER_URL + "/business-opportunity/constr-project"; // 工程项目
export const ENTERPRISE_MONITORING_URL = OLD_USER_CENTER_URL + "/userApplication_Monitor.html"; // 企业监控
export const RESET_PASSWORD_URL = OLD_USER_CENTER_URL + "/reset-password/"; // 忘记密码
export const BUSINESS_OPPORTUNITY_BIDDING_INFO = OLD_USER_CENTER_URL + "/business-opportunity/bidding-info"; // 招商机-标讯
export const BUSINESS_OPPORTUNITY_CONSTR_PROJECT = OLD_USER_CENTER_URL + "/business-opportunity/constr-project"; // 招商机-拟在建

export const BEIJING_ICP_CERTIFICATE_URL = "https://beian.miit.gov.cn/"; // 京ICP证160587号
export const BEIJING_PUBLIC_NETWORK = "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022728"; //京公网安备 11010802022728号

export const SALE_BEFORE_URL = "http://customer.qianlima.com/sale_before"; //在线咨询

export const SUBSCRIPTION_CENTER_SETTING_URL = OLD_USER_CENTER_URL + "/subscriptionCenter_Setting.html"; //订阅管理页
export const USER_APPLICATION_BUSINESS_ANALYSIS_URL = OLD_USER_CENTER_URL + "/userApplication_BusinessAnalysis.html"; //企业商请落地页
export const USER_APPLICATION_ADD_TENDER_URL = OLD_USER_CENTER_URL + "/userApplication_AddTender.html"; //发布招标

export const USER_APPLICATION_CONNECTIONS_URL = OLD_USER_CENTER_URL + "/userApplication_Connections.html"; //找人脉
export const USER_APPLICATION_MORE_CONTACTER_URL = OLD_USER_CENTER_URL + "/userApplication_MoreContacter.html"; //找人脉

export const BUSINESS_OPPORTUNITY_PURCHASE_INTENTION_URL =
  OLD_USER_CENTER_URL + "/business-opportunity/purchase-intention"; // 忘记密码
  export const CHOOSE_PACKAGE =  "/choose-package";
